<ng-container *ngIf="state$ | async as state" class="">
  <swal #noticeBoardSwalModal [showCloseButton]="true" [showConfirmButton]="false" [customClass]="{popup: 'w-10/12 md:w-6/12'}"  [heightAuto]="true"
    (didClose)="onClosed()">
    <div *swalPortal="swalTargets.content">
      <div id="notice-board-container" *ngIf="!state.loading; else loader">
        <div *ngIf="state.isEmptyNoticeList">Aucune affiche disponible.</div>
        <div *ngIf="!state.isEmptyNoticeList">
          <div *ngFor="let notice of state.notices" class="flex justify-center">
            <lpcr-notice-board-item #noticeBoardItem [title]="notice.title"
              [base64Image]="notice.base64Image" [contentText]="notice.contentText"
              [moreInformationURL]="notice.moreInformationURL" />
          </div>
        </div>

        <div class="flex flex-col lg:flex-row lg:justify-between mt-5">
          <div class="lg:w-80 mt-3">
            <input title="ignoreNoticeBoard" type="checkbox" id="ignoreNoticeBoard"
              [(ngModel)]="checkboxIgnoreNoticeBoard" (change)="onIgnoreNoticeBoardChange()"
              class="mr-2 mb-2 w-5 h-5 text-success">
            <label class="mt-5" for="ignoreNoticeBoard">Ne plus voir le panneau d'affichage</label>
          </div>
          <div class="flex lg:grow mt-3 lg:mt-0 justify-center" *ngIf="state.notices.length > 1">
            <button type="button" class="lpcr-button lpcr-button-primary me-2" variant="primary" (click)="previousNotice()">
              < 
            </button>
                <button type="button" class="lpcr-button lpcr-button-primary ms-2" variant="primary"
                  (click)="nextNotice()">
                  >
                </button>
          </div>
          <div class="flex justify-center lg:justify-end w-full lg:w-80 mt-3 lg:mt-0">
            <button type="button" class="lpcr-button lpcr-button-primary" variant="primary" (click)="close()">
              Fermer
            </button>
          </div>
        </div>
      </div>
    </div>
  </swal>

  <ng-template #loader>
    <lpcr-loading-indicator />
  </ng-template>
</ng-container>